import React, { useEffect, useRef } from 'react';


const SproutVideo: React.FC<{
  id: string;
  security_token: string;
  skip: number;
  className?: string;
  volume: number;
  showcontrols: boolean;
  autoPlay?: boolean
  seekBar?: boolean
  bigPlayButton?: boolean
}> = ({
  id,
  security_token,
  skip,
  className,
  volume,
  showcontrols,
  autoPlay,
  seekBar

}) => {
    console.log("volume", volume)

    console.log("id", id)

    console.log("security_token", security_token)

    return (
      // <div className={className}>
      <iframe
        id='sproutvideo'
        title="Presentation Video"
        className="sproutvideo-player"
        src={`https://videos.sproutvideo.com/embed/${id}/${security_token}?api=true&playsinline=true&${skip !== 0 ?
          "t=" + skip + "&" : ''}bigPlayButton=false&showcontrols=${showcontrols}
        &seekBar=true&fullscreenButton=false&volume=${volume}&autoplay=false&type=sd`}
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
      ></iframe>
      // </div>
    )
  }

export default SproutVideo;

